import { defineComponent } from 'vue';
export default defineComponent({
    name: 'WdTableColumnGroup',
    slots: ['title'],
    __ANT_TABLE_COLUMN_GROUP: true,
    render() {
        return null;
    },
});
